// src/components/ui/SearchEmptyState.js
import React from 'react';
import { SearchX } from 'lucide-react';

/**
 * Empty state component for search results
 * Shows centered icon and message when search returns no results
 */
const SearchEmptyState = ({ 
  primaryText = "No results match your search.",
  secondaryText = "Try a different search term.",
  italicizedWord = null // Word to italicize in secondaryText (e.g., "Archived")
}) => {
  // Helper to render secondary text with optional italicized word
  const renderSecondaryText = () => {
    if (!italicizedWord || !secondaryText.includes(italicizedWord)) {
      return secondaryText;
    }

    const parts = secondaryText.split(italicizedWord);
    return (
      <>
        {parts[0]}
        <em>{italicizedWord}</em>
        {parts[1]}
      </>
    );
  };

  return (
    <div className="flex flex-col items-center justify-center pt-app-lg pb-app-3xl">
      {/* SearchX icon - 64px tall, app-gray-400 */}
      <SearchX 
        size={48} 
        className="text-app-gray-400 mb-app-lg" 
        strokeWidth={1.5}
      />
      
      {/* Primary text - app-gray-900, app-xl */}
      <div className="text-app-md text-app-gray-900 mb-app-md text-center leading-tight">
        {primaryText}
      </div>
      
      {/* Secondary text - app-gray-600, app-sm */}
      <div className="text-center text-app-xs text-app-gray-600 leading-tight">
        {renderSecondaryText()}
      </div>
    </div>
  );
};

export default SearchEmptyState;